<template>
  <div v-show="active" class="stripe-wrapper" :class="{ 'has-error': !!error }">
    <div ref="stripe-input" class="stripe-input"></div>
    <div v-if="error" class="stripe-error" :style="{ backgroundColor: errorBg, color: errorColor }">
      <p>{{ error.message }}</p>
    </div>
  </div>
</template>

<script setup>
import { inject, useTemplateRef, watch } from 'vue';
const { ready, active, error, cardObject } = inject('$stripe');

const props = defineProps({
  errorBg: {
    type: String,
    required: false,
    default: "#ff0008",
  },
  errorColor: {
    type: String,
    required: false,
    default: "#fff",
  },
});

const stripeInput = useTemplateRef('stripe-input');

watch(ready, (newVal) => {
  if (newVal && cardObject.value && stripeInput.value) {
    cardObject.value.mount(stripeInput.value);
  }
});

</script>

<style lang="scss">
.stripe-wrapper {
  transition: border-color 0.2s, box-shadow 0.2s;
  position: relative;
  border: 1px solid #000;
  height: 60px;

  &.has-error {
    border-color: #ff0008 !important;
    box-shadow: 0 0 0 2px rgba(255,0,8,0.18);
  }

  .stripe-input {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    right: 0;
    padding-left: 10px;
  }

  .stripe-error {
    position: absolute;
    top: 0px;
    right: 5px;
    transform: translateY(-100%);
    padding: 5px 10px;
    z-index: 5;

    p {
      text-transform: uppercase;
      font-size: 0.5rem;
      letter-spacing: 0.05rem;
    }
  }
}
</style>